import { httpLoginClient } from "../network/httpclient/HttpClientFactory";

import router from "../router";

const login = (param, headerParam) =>
  httpLoginClient
    .post("/member/login", param, { headers: headerParam })
    .then((res) => res.data);

const logout = () => {
  router.push({ name: "Login" });
  localStorage.clear();
};

export default {
  login,
  logout,
};
